<template>
  <div id="healthcheck">
    <p>Healthy!</p>
  </div>
</template>

<script>

export default {
  name: 'Healthcheck',
};
</script>

<style>
</style>
